import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';

const Delay = () => {
  const [sipAmount, setSipAmount] = useState(10000);
  const [sipDuration, setSipDuration] = useState(120); 
  const [expectedReturn, setExpectedReturn] = useState(12);
  const [sipDelay, setSipDelay] = useState(15); 
  const [result, setResult] = useState(null);

  const calculateDelay = () => {
    const r = expectedReturn / 100 / 12;

    // Maturity if invested today
    const maturityToday = sipAmount * ((Math.pow(1 + r, sipDuration) - 1) * (1 + r)) / r;

    // Maturity if delayed
    const delayDuration = sipDuration - sipDelay;
    const maturityDelayed = sipAmount * ((Math.pow(1 + r, delayDuration) - 1) * (1 + r)) / r;

    const costOfDelay = maturityToday - maturityDelayed;

    setResult({
      maturityToday,
      maturityDelayed,
      costOfDelay,
    });
  };

  const pieData = result && {
    labels: ['Invested Today', `Invested After ${sipDelay} Months`],
    datasets: [
      {
        data: [result.maturityToday, result.maturityDelayed],
        backgroundColor: ['#004aad', '#76d041'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className='sip-calculator'>
      <h2>Delay Cost Calculator</h2>

      <div className='input-group'>
        <label>Monthly SIP Amount</label>
        <input
          type='range'
          min='100'
          max='100000'
          step='100'
          value={sipAmount}
          onChange={(e) => setSipAmount(Number(e.target.value))}
        />
        <input
          type='number'
          min='100'
          max='100000'
          value={sipAmount}
          onChange={(e) => {
            const val = e.target.value;
            setSipAmount(val === '' ? '' : Number(val));
          }}
          className='value-box'
        />
      </div>

      <div className='input-group'>
        <label>SIP Duration (In Months)</label>
        <input
          type='range'
          min='1'
          max='500'
          step='1'
          value={sipDuration}
          onChange={(e) => setSipDuration(Number(e.target.value))}
        />
        <input
          type='number'
          min='1'
          max='500'
          value={sipDuration}
          onChange={(e) => {
            const val = e.target.value;
            setSipDuration(val === '' ? '' : Number(val));
          }}
          className='value-box'
        />
      </div>

      <div className='input-group'>
        <label>Expected Return (%)</label>
        <input
          type='range'
          min='1'
          max='100'
          value={expectedReturn}
          onChange={(e) => setExpectedReturn(Number(e.target.value))}
        />
        <input
          type='number'
          min='1'
          max='100'
          value={expectedReturn}
          onChange={(e) => {
            const val = e.target.value;
            setExpectedReturn(val === '' ? '' : Number(val));
          }}
          className='value-box'
        />
      </div>

      <div className='input-group'>
        <label>Delay in Starting SIP (Months)</label>
        <input
          type='range'
          min='1'
          max='100'
          value={sipDelay}
          onChange={(e) => setSipDelay(Number(e.target.value))}
        />
        <input
          type='number'
          min='1'
          max='100'
          value={sipDelay}
          onChange={(e) => {
            const val = e.target.value;
            setSipDelay(val === '' ? '' : Number(val));
          }}    
          className='value-box'
        />
      </div>

      <button onClick={calculateDelay} className='calculate-btn'>
        Calculate
      </button>

      {result && (
        <div className='sip-output-section'>
          <div className='result-summary'>
            <h3>Delay Cost Calculation</h3>
            <p> Maturity Value if Invested Today: <strong style={{color:'#76d041'}}>₹{result.maturityToday.toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong></p>
            <p> Maturity Value If Invested After {sipDelay} Months: <strong style={{color:'#76d041'}}>₹{result.maturityDelayed.toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong></p>
            <p> The Cost of Delay is: <strong style={{color:'#76d041'}}>₹{result.costOfDelay.toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong></p>
          </div>

          <div className='pie-chart-container'>
            <h3>Delay Cost Calculate Graph</h3>
            <Pie data={pieData} />
          </div>
        </div>
      )}

    </div>
  );
};

export default Delay;
